import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import img1 from "../assets/images/noimage.jpg";
import { MyApi } from "../MyApi";
import useSEO from "../hooks/useSEO"; // adjust path if needed

export default function ToursList() {
  const { categorySlug } = useParams();
  const [category, setCategory] = useState(null);
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCategoryTours = async () => {
      try {
        const res = await axios.get(
          `${MyApi.BASE_URL}tours-list/${categorySlug}`,
          { headers: { Authorization: MyApi.SECRET_KEY } }
        );

        if (res.data.status) {
          setCategory(res.data.category);
          setTours(res.data.data || []);
        } else {
          setError(res.data.message || "No data found");
        }
      } catch (err) {
        console.error("API error:", err);
        setError("API request failed");
      } finally {
        setLoading(false);
      }
    };

    fetchCategoryTours();
  }, [categorySlug]);

  // ✅ SEO META TAGS (Dynamic per category)
  useSEO({
    title: category?.meta_title
      || `${category?.categoryheading || "Varanasi Tours"} | Kashi Journeys`,
    description: category?.meta_description
      || `Explore the best ${category?.categoryheading || "Varanasi"} tour packages with Kashi Journeys. Authentic local experiences, expert guides, temples, ghats & spiritual heritage.`,
    keywords: category?.meta_tags
      || "Varanasi tours, Kashi Journeys, Banaras sightseeing, Varanasi travel packages, local tours Varanasi",
    canonical: window.location.href,
    ogImage: tours?.[0]?.image_url || "",
  });

  if (loading) return <p className="text-center py-5">Loading tours...</p>;
  if (error) return <p className="text-center py-5">{error}</p>;

  return (
    <div className="bg_image experts">
      <Container>
        <div className="servi_bx">
          <div className="heading_a text-center mb-4">
            <span>Explore Tours</span>
            <h3>{category?.categoryheading || "Tour Packages"}</h3>
          </div>

          <Row>
            {tours.length > 0 ? (
              tours.map((tour) => (
                <Col md="4" key={tour.id}>
                  <div className="custom-figure mb-4">
                    <Link to={`/${category.categoryurl}/${tour.producturl}`}>
                      <img
                        src={tour.image_url || img1}
                        alt={tour.productname}
                        className="img-fluid"
                      />
                    </Link>

                    <Link
                      to={`/${category.categoryurl}/${tour.producturl}`}
                      className="figcaption"
                    >
                      <h3>{tour.productname}</h3>
                      <div className="d-none">
                       {(Number(tour?.price) > 0 || Number(tour?.net_wt) > 0) && (
                          <Row>
                            {Number(tour?.price) > 0 && (
                              <Col>₹{tour.price}</Col>
                            )}
  
                           {Number(tour?.net_wt) > 0 && (() => {
                            const totalHours = Number(tour.net_wt);
                            const hours = Math.floor(totalHours);
                            const minutes = Math.round((totalHours - hours) * 60);

                            if (hours > 0 && minutes > 0) {
                              return <p>Duration <strong>{hours}h {minutes}m</strong></p>;
                            } else if (hours > 0) {
                              return <p>Duration <strong>{hours}h</strong></p>;
                            } else {
                              return <p>Duration <strong>{minutes}m</strong></p>;
                            }
                          })()}

                          </Row>
                        )}
                        </div>
                      <p>{tour.productshortcontent || ""}</p>
                    </Link>
                  </div>
                </Col>
              ))
            ) : (
              <Col>
                <p className="text-center">No tours found in this category</p>
              </Col>
            )}
          </Row>
        </div>
      </Container>
    </div>
  );
}
